export interface Subscription {
    id: number;
    user_type_id: number;
    order_number: string
    plan_name: string;
    monthly: number;
    fixed_amount: number;
    max_license_counts: number;
    numberOfProjects: number;
    feature: Feature[];
    tax_percentage?: number;
}

export const mapSubscription = (data: any): Subscription => {
    if (!data) {
      throw new Error('Invalid user type data');
    }
  
    const subscription: Subscription = {
      id: data.id,
      user_type_id: data.user_type_id,
      order_number: data.order_number,
      plan_name: data.plan_name,
      monthly: data.monthly,
      fixed_amount: data.fixed_amount,
      max_license_counts: data.max_license_counts,
      numberOfProjects: 1,
      feature: mapFeatures(data.feature),
      tax_percentage: data.tax_percentage,
    };
  
    return subscription;
  };

  export const mapSubscriptions = (data: any[]): Subscription[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Subscription data');
    }
  
    return data.map(mapSubscription);
  };


export interface Feature {
    feature_name: string;
}

export const mapFeature = (data: any): Feature => {
    if (!data) {
      throw new Error('Invalid Feature data');
    }
  
    const feature: Feature = {
        feature_name: data.feature_name,
    };
  
    return feature;
  };

  export const mapFeatures = (data: any[]): Feature[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Feature data');
    }
  
    return data.map(mapFeature);
  };